import React from 'react'
import Page from 'src/components/Page'
import {
  Grid, Typography, makeStyles, Button,
} from '@material-ui/core'
import { Route, Routes, Link } from 'react-router-dom'
import { Bell } from 'react-feather'
import List from './List'
import Form from './Form'

const useStyle = makeStyles(() => ({
  root: {
    padding: 20,
  },
  header: {
    marginBottom: 15,
  },
  chips: {
    margin: '0px 4px',
    paddingLeft: 10,
    paddingRight: 10,
  },
}))

export const Admin = () => {
  const classes = useStyle()

  return (
    <Page
      className={classes.root}
      title="اعلانیه"
    >
      <Grid container justify="space-between" className={classes.header}>
        <Typography variant="h3" component="h3">اعلانیه</Typography>
        <Link to="create-notification">
          <Button variant="contained" color="primary" startIcon={<Bell size={16} />}>ایجاد اعلانیه جدید</Button>
        </Link>
      </Grid>
      <Routes>
        <Route path="/" element={<List />} />
        <Route path="create-notification" element={<Form />} />
      </Routes>
    </Page>
  )
}

export default Admin
